import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useToast } from '../../contexts/ToastContext';
import sessionService from '../../services/sessionService';
import ConsolidatedOrderLanguageModal from '../ConsolidatedOrderLanguageModal/ConsolidatedOrderLanguageModal';

const ConsolidatedOrderDownloadButton = ({
  sessionId,
  isAdmin,
  isFournisseur,
  hasDownloadPermission,
}) => {
  const { t, i18n } = useTranslation();
  const toast = useToast();
  const [downloading, setDownloading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const visible = !isFournisseur && (isAdmin || hasDownloadPermission);

  if (!visible) {
    return null;
  }

  const handleDownload = async (lang) => {
    setDownloading(true);
    try {
      const response = await sessionService.downloadConsolidatedInvoice(
        sessionId,
        lang
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const dateStamp = new Date()
        .toISOString()
        .split('T')[0]
        .replace(/-/g, '');
      link.download = `Commande_consolidee_Session_${dateStamp}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success(t('sessions.detail.consolidatedInvoiceDownloaded'));
      setModalOpen(false);
    } catch (error) {
      toast.error(t('sessions.detail.errors.downloadConsolidatedInvoice'));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => setModalOpen(true)}
        disabled={downloading}
        style={{
          width: '100%',
          marginTop: '0.75rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
        }}
      >
        <FileText size={18} />
        {t('sessions.detail.downloadConsolidatedInvoice')}
      </button>
      <ConsolidatedOrderLanguageModal
        isOpen={modalOpen}
        initialLanguage={i18n.language}
        loading={downloading}
        onClose={() => setModalOpen(false)}
        onGenerate={handleDownload}
      />
    </>
  );
};

export default ConsolidatedOrderDownloadButton;
